<template>
  <div>
    <b-modal id="bv-modal-edit-banking" size="lg" hide-footer>
      <template #modal-title>Edit banking</template>

      <div class="row">
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Bank Name</label>
            <input class="form-control2" v-model="user.bank_name">
        </div>
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Account Name</label>
            <input class="form-control2" v-model="user.bank_account_name">
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Account Number</label>
            <input class="form-control2" v-model="user.bank_account_number">
        </div>
        <div class="col-md-6">
            <label class="form-label pt-2 mb-2">Branch Code</label>
            <input class="form-control2" v-model="user.bank_branch_code">
        </div>
      </div>

      <div class="row mt-3 pb-2">
        <div class="col mt-2 mt-md-0">
            <button v-if="updating" type="button" class="btn btn-danger submit col">
            <i class="fas fa-spinner fa-sm fa-spin mr-2 move-up"></i></button>
            <button v-else type="button" class="btn btn-danger submit col" @click="saveBanking">Save</button>
        </div>
      </div>

    </b-modal>
  </div>
</template> 

<script>
import { EventBus } from '../bus';

export default {
props: ['user'],
  data() {
    return {
      updating: false,
    };
  },

  methods: {

    hideModalEditBanking() {
      this.$bvModal.hide('bv-modal-edit-banking');
    },

            saveBanking() {

            if (!this.user.bank_name) { this.sweetfire('Please enter bank name'); return; }
            else if (!this.user.bank_account_name) { this.sweetfire('Please enter account name'); return; }
            else if (!this.user.bank_account_number) { this.sweetfire('Please enter account number'); return; }
            else if (!this.user.bank_branch_code) { this.sweetfire('Please enter branch code'); return; }

            else {

              this.updating = true;

                axios.post('/profile/save', {
                  bank_name: this.user.bank_name,
                  bank_account_name: this.user.bank_account_name,
                  bank_account_number: this.user.bank_account_number,
                  bank_branch_code: this.user.bank_branch_code,
                })
                .then((response) => {

              if (response.data.success) {
                    EventBus.$emit('banking-updated', {
                        bank_name: this.user.bank_name,
                        bank_account_name: this.user.bank_account_name,
                        bank_account_number: this.user.bank_account_number,
                        bank_branch_code: this.user.bank_branch_code,
                    });
                    this.successAlert(response.data.message);
                    this.hideModalEditBanking();
                } else {
                    this.sweetfire(response.data.message);
                }

                this.updating = false;

              });

            }

          },

      // sweet alert for 3 seconds
      successAlert(text) {

        Swal.fire({
            title: text,
            customClass: {
                title: "popup-title",
                icon: 'custom-icon-size'
            },
            icon: 'success',
            showConfirmButton: false,
            timer: 3000,
            });
      },

      sweetfire(text) {

      Swal.fire({
      title: text,
      showConfirmButton: false,
      showDenyButton: false,
      showCancelButton: true,
      focusConfirm: false,
      cancelButtonText: 'Ok',
      customClass: {
              title: "popup-title",
            },
    })

    },
  },
};
</script>

<style scoped>
textarea.form-control { font-size: 0.9rem !important; }
</style>